export default __webpack_public_path__ + "static/media/UMMM.c9279015.png";